module.exports = __webpack_public_path__ + "static/Lato-Bold-2032f2b161a7a109a9d0cc3f6ad3b735.woff";